import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "menu-close",
  "use": "menu-close-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"menu-close\">\n    <path d=\"M12.4137 10.9997L21.7065 1.70694L20.2923 0.292725L10.9995 9.58551L1.70685 0.292875L0.292632 1.70709L9.58527 10.9997L0.29248 20.2925L1.70669 21.7067L10.9995 12.4139L20.2924 21.7069L21.7066 20.2927L12.4137 10.9997Z\" style=\"fill:var(--fill,#276BFB)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol